import { TipoInstituto } from '../../enum/parametros/tipo-instituto.enum';
import { InstitutoPlano } from '../../models/parametros/plano-institutos.model';
import {
  CreateInstitutoParamCommandDto,
  InstitutoParamResponseDto,
  PatchInstitutoParamCommandDto,
  TipoInstitutoResponseDto,
} from '../../models/parametros/instituto-param-api.model';
import { Instituto } from '../../models/parametros/resgate-configuracao.model';
import { extractIsoDate, toApiDateTime } from '../../utils/date-format.util';

/** `NOME` (único) de cada tipo em PRE_TBL_INSTITUTO_TIPOS, comparado sem diferenciar maiúsculas. */
export const NOME_TIPO_INSTITUTO: Record<TipoInstituto, string> = {
  [TipoInstituto.Resgate]: 'RESGATE',
  [TipoInstituto.Portabilidade]: 'PORTABILIDADE',
  [TipoInstituto.BeneficioProporcionalDiferido]: 'BPD',
  [TipoInstituto.Autopatrocinio]: 'AUTOPATROCINADO',
};

/** Tipos com tela de configuração. */
const TIPOS_CONFIGURAVEIS: readonly TipoInstituto[] = [TipoInstituto.Resgate];

export function tipoInstitutoDoNome(nome: string | null | undefined): TipoInstituto | null {
  const normalizado = nome?.trim().toUpperCase();
  const tipo = Object.entries(NOME_TIPO_INSTITUTO).find(([, item]) => item === normalizado)?.[0];
  return (tipo as TipoInstituto | undefined) ?? null;
}

/** Tipos que não correspondem a nenhum instituto conhecido ficam de fora (`null`). */
export function tipoInstitutoDtoToInstituto(dto: TipoInstitutoResponseDto): Instituto | null {
  const tipo = tipoInstitutoDoNome(dto.nome);
  if (!tipo) {
    return null;
  }

  return {
    tipo,
    nome: (dto.nome_exibicao ?? dto.nome ?? '').trim(),
    habilitado: TIPOS_CONFIGURAVEIS.includes(tipo) && dto.fl_status !== false,
  };
}

/** Instituto inativo não fica disponível para o participante. */
export function institutoParamDtoToInstitutoPlano(dto: InstitutoParamResponseDto): InstitutoPlano {
  return {
    id: dto.id,
    tipo: tipoInstitutoDoNome(dto.tipo_instituto?.nome),
    nome: (dto.tipo_instituto?.nome_exibicao ?? dto.tipo_instituto?.nome ?? '').trim(),
    status: dto.fl_ativo ? 'Ativo' : 'Inativo',
    vigenciaInicio: extractIsoDate(dto.dt_ini_vig),
    vigenciaFim: extractIsoDate(dto.dt_fim_vig),
    disponivelParticipante: dto.fl_ativo && dto.fl_disp_participante,
  };
}

export function institutoPlanoToPatchCommand(instituto: InstitutoPlano): PatchInstitutoParamCommandDto {
  return {
    fl_ativo: instituto.status === 'Ativo',
    fl_disp_participante: instituto.status === 'Ativo' && instituto.disponivelParticipante,
  };
}

export function institutoParamDtoToCopiaCommand(
  dto: InstitutoParamResponseDto,
  planoDestino: number,
): CreateInstitutoParamCommandDto {
  return {
    id_plano: planoDestino,
    id_tp_inst: dto.id_tp_inst,
    dt_ini_vig: toApiDateTime(extractIsoDate(dto.dt_ini_vig)),
    dt_fim_vig: dto.dt_fim_vig ? toApiDateTime(extractIsoDate(dto.dt_fim_vig)) : null,
    fl_disp_participante: dto.fl_disp_participante,
    fl_ativo: dto.fl_ativo,
    desc_param: dto.desc_param ?? '',
  };
}
